export class MenuModel {
  title = '';
  value = '';
}
